import { render } from "./VistaCol.vue?vue&type=template&id=29cc466c&scoped=true"
import script from "./VistaCol.vue?vue&type=script&lang=js"
export * from "./VistaCol.vue?vue&type=script&lang=js"

import "./VistaCol.vue?vue&type=style&index=0&id=29cc466c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29cc466c"

export default script